module.exports = __webpack_public_path__ + "0af458a9bb24da792ce508b292441248.png";